import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  mediaBar: {
    position: 'absolute',
    zIndex: 2,
    display: 'flex',
    gap: 8,
    padding: 4,
    backgroundColor: '#FFFFFF',
  },
  root: {
    position: 'relative',
    '& .ql-toolbar': {
      borderRadius: '4px 4px 0 0',
    },
    '& .ql-container': {
      borderRadius: '0 0 4px 4px',
      fontSize: 16,
    },
    '& .ql-editor': {
      minHeight: '22rem',
    },
    '& .ql-tooltip': {
      zIndex: 1,
      whiteSpace: 'nowrap',
    },
    '& .ql-editor img': {
      maxWidth: '100%',
      height: 'auto',
    },
    '& .ql-editor .ql-video, & .ql-editor .ql-video-file': {
      display: 'block',
      width: '100%',
      maxWidth: 720,
      aspectRatio: '16 / 9',
      margin: '8px auto',
    },
    // Player do Spotify tem altura fixa: faixa/episódio compacto, demais (álbum, playlist...) maior.
    '& .ql-editor .ql-video[src*="open.spotify.com"]': {
      aspectRatio: 'auto',
      height: 352,
      maxWidth: 720,
      borderRadius: 12,
      backgroundColor: 'transparent',
    },
    '& .ql-editor .ql-video[src*="/embed/track/"], & .ql-editor .ql-video[src*="/embed/episode/"]': {
      height: 152,
    },
  },
}));
